const Form = () => {
  return (
    <form action="">
      <input id="formMessage" type="text" />
      <label htmlFor="formMessage"></label>
      <button>OK</button>
    </form>
  );
};

export default Form;
